import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const CenteredCircularProgress = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    <CircularProgress />
  </Box>
);

export default CenteredCircularProgress;
